export default function MailIcon(props) {
  return (
    <>
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`cursor-pointer ${props.className ?? ""}`}
      >
        <path
          d="M14.5 0.75H3.5C2.77065 0.75 2.07121 1.03969 1.55548 1.55542C1.03976 2.07114 0.75 2.77065 0.75 3.5V10.5C0.75 11.2293 1.03976 11.9288 1.55548 12.4445C2.07121 12.9602 2.77065 13.25 3.5 13.25H14.5C15.2293 13.25 15.9289 12.9602 16.4446 12.4445C16.9603 11.9288 17.25 11.2293 17.25 10.5V3.5C17.2474 2.77147 16.9568 2.0735 16.4417 1.55835C15.9265 1.04319 15.2285 0.752635 14.5 0.75ZM3.5 2.25H14.5C14.694 2.25166 14.8851 2.29606 15.06 2.38L10.13 7.31C9.99186 7.45068 9.82682 7.56211 9.64471 7.6377C9.46261 7.71329 9.26717 7.7515 9.07001 7.75H8.89001C8.69277 7.75207 8.49713 7.71411 8.31494 7.63849C8.13276 7.56287 7.96781 7.45114 7.83002 7.31L2.90002 2.38C3.08703 2.29012 3.29256 2.24558 3.5 2.25ZM2.25 3.81L5.44 7L2.25 10.19V3.81ZM14.5 11.75H3.5C3.30605 11.7483 3.11485 11.7039 2.94 11.62L6.5 8.06L6.81 8.38C7.3737 8.93911 8.13604 9.25196 8.92999 9.25H9.07001C9.86539 9.2493 10.6279 8.93277 11.19 8.37L11.5 8.06L15.06 11.62C14.8851 11.7039 14.694 11.7483 14.5 11.75ZM15.75 10.19L12.56 7L15.75 3.81V10.19Z"
          fill={props.fill ?? "white"}
        />
      </svg>
    </>
  );
}
